module.exports = "<div class=\"title-bar-container\">\r\n    <div class=\"title-bar\">\r\n        <img src=\"" + require("../../assets/images/logo.png") + "\" *ngIf=\"screenService.isLarge()\">\r\n        <div class=\"menu-area\">\r\n            <fw-top-bar>\r\n            </fw-top-bar>\r\n        </div>\r\n    </div>\r\n    <div class=\"title-bar-line\">\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/title-bar/title-bar.component.html
// module id = 1859
// module chunks = 1